import React, { useContext, useEffect } from 'react';
import Interventions from 'app/edozvola/cases/construction-building-procedure/interventions/interventions';
import Buildings from './buildings/buildings';
import Constructions from 'app/edozvola/cases/construction-building-procedure/constructions/constructions';
import { FormikProvider, useFormik } from 'formik';
import {
  ConstructionBuildingProcedure,
  initialConstructionBuildingProcedure,
} from 'app/edozvola/cases/construction-building-procedure/model/construction-building-procedure.model';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import {
  fetchConstructionBuildingProcedureCodebooksQuery,
  fetchConstructionBuildingProcedureVariantQuery,
  saveConstructionBuildingProcedureCodebooksQuery,
} from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';
import { useParams } from 'react-router-dom';
import { Loader } from 'app/shared/loader/loader';
import { useDispatch } from 'react-redux';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import {
  fetchBuildingNumberQuery,
  fetchConstructionNumberQuery,
  fetchProcedureNumberQuery
} from 'app/edozvola/codebooks/codebooks.queries';
import { getCaseContext } from 'app/shared/util/context-util';

const ConstructionBuildingProcedure = ({loaderData = null}) => {
  const { id: uuid } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { sidebarItemPair } = getCaseContext();

  const { data: cbpData, isLoading: cbpDataLoading } = fetchConstructionBuildingProcedureCodebooksQuery(uuid);
  const { data: buildingNumberOptions, isLoading: buildingNumberOptionsLoading } = fetchBuildingNumberQuery();

  const { data: constructionNumberOptions, isLoading: constructionNumberOptionsLoading } = fetchConstructionNumberQuery();

  const { data: procedureNumberOptions, isLoading: procedureNumberOptionsLoading } = fetchProcedureNumberQuery();

  const constructionBuildingProcedureVariant = loaderData;

  const formik = useFormik({
    initialValues: cbpData || initialConstructionBuildingProcedure,
    onSubmit: (values: ConstructionBuildingProcedure) => {
      saveCbpMutation(values);
    },
    enableReinitialize: true,
    validateOnMount: true,
  });

  const { mutate: saveCbpMutation, isPending: isCbpSaving } = saveConstructionBuildingProcedureCodebooksQuery(uuid, () => {});

  useEffect(() => {
    if (formik.dirty) {
      dispatch(setFormChanged(true));
    } else {
      dispatch(initCaseFormChange());
    }
  }, [formik.dirty]);

  return (
    <div>
      {cbpDataLoading && <Loader />}
      {!cbpDataLoading && (
        <>
          <FormikProvider value={formik}>
            <Buildings
              buildingNumberOptions={buildingNumberOptions}
              isBuildingNumberOptionsLoading={buildingNumberOptionsLoading}
              selectedBuildingNumberOption={formik.values.buildingNumber}
              setBuildingNumberOptions={value => formik.setFieldValue('buildingNumber', value)}
              formik={formik}
              variant={constructionBuildingProcedureVariant}
            />
            <hr />
            <Constructions
              constructionNumberOptions={constructionNumberOptions}
              isConstructionNumberOptionLoading={constructionNumberOptionsLoading}
              selectedConstructionNumberOption={formik.values.constructionNumber}
              setConstructionNumberOptions={value => formik.setFieldValue('constructionNumber', value)}
              formik={formik}
              variant={constructionBuildingProcedureVariant}
            />
            <hr />
            <Interventions
              variant={constructionBuildingProcedureVariant}
              formik={formik}
              procedureNumberOptions={procedureNumberOptions}
              procedureNumberIsLoading={procedureNumberOptionsLoading}
              selectedProcedureNumberOption={formik.values.procedureNumber}
              setProcedureNumberOption={selectedOption => formik.setFieldValue('procedureNumber', selectedOption)}
            />
            {!sidebarItemPair?.readOnly && (
              <div className={'case-save-button'}>
                <Button
                  label={'Spremi'}
                  size={'lg'}
                  disabled={!formik.dirty || !formik.isValid}
                  isLoading={isCbpSaving}
                  color={'info'}
                  onClick={() => formik.handleSubmit()}
                />
              </div>
            )}
          </FormikProvider>
        </>
      )}
    </div>
  );
};

export default ConstructionBuildingProcedure;
